export enum SameSiteOption {
  STRICT = 'Strict',
  LAX = 'Lax',
  NONE = 'None'
}

export type Cookie = {
  key: string
  value: string
  isSecure?: boolean
  maxAge?: number
  sameSite?: SameSiteOption
  path?: string
}
